import { Typography } from "@material-ui/core";
import { isLandlordTypeGuard } from "common/models/userInfo";
import React, { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import { createSelector } from "reselect";
import ChosenNode from "../../nodeDetails/components/ChosenNode";
import { getInstallations } from "../../nodeDetails/nodeDetails.actions";
import { IApplicationState } from "../../redux/root-reducer";
import TabsContainer from "../../tabsContainer/components/TabsContainer";
import styles from "./SafetySensors.module.scss";

const getCurrentNodeItems = createSelector(
  (state: IApplicationState) => state.node,
  (state) => ({
    node: state.selectedNode,
  })
);

const getDomainSelector = createSelector(
  (state: IApplicationState) => state.common,
  (commonState) => ({
    isLandlord: isLandlordTypeGuard(commonState.currentUserInfo),
    userIsReady: commonState.userIsReady,
  })
);

const SafetySensorsView = () => {
  const { node } = useSelector(getCurrentNodeItems);
  const address = useSelector(
    (store: IApplicationState) => store.sensors.allSensorDataForSingleNode[0]?.Address
  );
  
  const { userIsReady, isLandlord } = useSelector(getDomainSelector);

  const dispatch = useDispatch();
  const { id, domain }: {id?: string, domain?: string} = useParams();

  useEffect(() => {
    if (userIsReady) {
      dispatch(getInstallations(domain!, parseInt(id!)));
    }
  }, [id, userIsReady]);

  const { t } = useTranslation();
  return (
    <div className={styles.container}>
      {isLandlord && (
        <div>
          <Typography className={styles.address}>
            {address ? address : t("Building information is missing")}
          </Typography>
        </div>
      )}
      <ChosenNode chosenNode={node} />
      <TabsContainer />
    </div>
  );
};

export default SafetySensorsView;
